import { categories } from "@/mocks/videos";

const catMeta: Record<string, { icon: string; desc: string; count: string }> = {
  娱乐八卦: { icon: "ri-message-2-line", desc: "明星动态、圈内新鲜事", count: "1200+ 视频" },
  社会热点: { icon: "ri-flashlight-line", desc: "民生百态、暖心瞬间", count: "860+ 视频" },
  明星现场: { icon: "ri-user-star-line", desc: "演唱会、首映礼、红毯", count: "640+ 视频" },
  生活趣事: { icon: "ri-store-2-line", desc: "探店、美食、搞笑日常", count: "980+ 视频" },
  萌宠日常: { icon: "ri-heart-3-line", desc: "毛孩子的欢乐瞬间", count: "720+ 视频" },
  街头采访: { icon: "ri-mic-line", desc: "路人的真实心里话", count: "450+ 视频" },
};

interface CategoryExploreProps {
  onSelect: (category: string) => void;
}

export default function CategoryExplore({ onSelect }: CategoryExploreProps) {
  const items = categories.filter((c) => c !== "全部");

  return (
    <section id="categories" className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center">
          <p className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
            <i className="ri-layout-grid-line"></i>
            吃瓜分类
          </p>
          <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-3xl">
            按类型轻松找视频
          </h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-600">
            六大分类一站直达，点击进入即可看到对应栏目的最新内容，追更不迷路。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((c) => (
            <button
              key={c}
              type="button"
              onClick={() => onSelect(c)}
              className="group flex items-center gap-4 rounded-lg bg-background-50 p-4 text-left ring-1 ring-background-200 transition-colors hover:bg-primary-500 md:p-5"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-accent-100 text-accent-700 transition-colors group-hover:bg-background-50/20 group-hover:text-background-50">
                <i className={`${catMeta[c].icon} text-2xl`}></i>
              </span>
              <span>
                <span className="block text-sm font-medium text-foreground-950 group-hover:text-background-50 md:text-base">
                  {c}
                </span>
                <span className="mt-0.5 block text-xs text-foreground-600 group-hover:text-background-100/90">
                  {catMeta[c].desc}
                </span>
                <span className="mt-1 block text-xs text-accent-700 group-hover:text-accent-200">
                  {catMeta[c].count}
                </span>
              </span>
              <i className="ml-auto text-lg text-foreground-300 group-hover:text-background-50 ri-arrow-right-s-line"></i>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}